import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  items = new BehaviorSubject<{ code: number, priceID: number }[]>([]);

  constructor(@Inject(PLATFORM_ID) private platformId: string) {
    this.items.next(this.get());
  }

  add(code: number, priceID: number): boolean {
    if (this.items.value.findIndex(it => it.code === code) === -1) {
      this.items.value.push({ code, priceID });
      this.items.next(this.items.value);
      this._update();
      return true;
    }
    return false;
  }

  update(code: number, priceID: number) {
    const item = this.items.value.find(it => it.code === code);
    if (_.isNil(item)) {
      return;
    }
    item.priceID = priceID;
    this._update();
  }

  remove(code: number) {
    _.remove(this.items.value, it => it.code === code);
    this.items.next(this.items.value);
    this._update();
  }

  get() {
    if (isPlatformBrowser(this.platformId)) {
      try {
        const cart = JSON.parse(localStorage.getItem('cart'));
        return (_.isNil(cart) || !_.isArray(cart)) ? [] : cart;
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  private _update() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('cart', JSON.stringify(this.items.value));
    }
  }

}
